import {
  SHOW_CREATE_PROJECT,
  HIDE_CREATE_PROJECT,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_VIEW,
  SHOW_UPDATE_PROJ, HIDE_UPDATE_PROJ, SHOW_COPY_PROJECT, SHOW_TAGS, FETCH_LOOKUP_START,
  CONF_ROUTING_CHECK_START,
  GET_CONF_SESSIONID_START,
  CONFIT_CREATE_QUOTE_START,
  CONFIT_UPDATE_QUOTE_START
} from "./ctrlTypes";
import { showCrProj, hideCrProj, showLoader, refreshApp, setView, showUpdProj, hideUpdProj, showCopyProj, showTags, fetchLookupSuccessAct, fetchLookupFailureAct, confRoutingCheckSuccessAct, confRoutingCheckFailureAct, getConfSessionIDSuccessAct, getConfSessionIDFailureAct, confUpdateQuoteFailureAct, confUpdateQuoteSuccessAct, confCreateQuoteSuccessAct, confCreateQuoteFailureAct } from "./ctrlActions";
import { call, takeLatest, put, takeEvery } from "@redux-saga/core/effects";
import { getLPAPI, getConfRoutingDetailsAPI, getConfSessionIDAPI, confCreateQuoteAPI, confUpdateQuoteAPI } from "../../apis/pgapis";


export function* onShowCrProjSync(payload) {
  try {
    yield call(showCrProj, payload);
  } catch (e) { }
}

export function* onShowCrProj() {
  yield takeLatest(SHOW_CREATE_PROJECT, onShowCrProjSync);
}

export function* onShowCopyProjSync(payload) {
  try {
    yield call(showCopyProj, payload)
  } catch (e) { }
}

export function* onShowCopyProj() {
  yield takeLatest(SHOW_COPY_PROJECT, onShowCopyProjSync);
}

export function* onHideCrProjSync(payload) {
  try {
    yield call(hideCrProj, payload);
  } catch (e) { }
}

export function* onHideCrProj() {
  yield takeLatest(HIDE_CREATE_PROJECT, onHideCrProjSync);
}

export function* onShowLoaderSync(payload) {
  try {
    yield call(showLoader, payload);
  } catch (e) { }
}

export function* onShowLoader() {
  yield takeLatest(SHOW_LOADER, onShowLoaderSync);
}

export function* onHideLoaderSync(payload) {
  try {
    yield call(onHideLoader, payload);
  } catch (e) { }
}
export function* onHideLoader() {
  yield takeLatest(HIDE_LOADER, onHideLoaderSync);
}

export function* onSetViewSync(payload) {
  try {
    yield call(setView, payload);
  } catch (e) { }
}

export function* onSetView() {
  yield takeLatest(SET_VIEW, onSetViewSync);
}

export function* onShowUpdProjSync(payload) {
  yield call(showUpdProj, payload)
}

export function* onShowUpdProj() {
  yield takeLatest(SHOW_UPDATE_PROJ, onShowUpdProjSync)
}

export function* onHideUpdProjSync(payload) {
  yield call(hideUpdProj, payload)
}

export function* onHideUpdProj() {
  yield takeLatest(HIDE_UPDATE_PROJ, onHideUpdProjSync)
}

export function* onShowTagsSync(payload) {
  yield call(showTags, payload)
}
export function* onShowTags() {
  yield takeLatest(SHOW_TAGS, onShowTagsSync)
}

export function* onFetchLookupAsync(action) {
  try {
    yield put(showLoader(true));
    const response = yield call(getLPAPI, { lnames: action.lookupNames });
    yield put({
      type: "FETCH_LOOKUP_SUCCESS",
      payload: response
    });
    yield put(showLoader(false));
  } catch (e) {
    if (e?.response?.status === 403) {
      yield put(refreshApp(true));
    }
    yield put({
      type: "FETCH_LOOKUP_FAILURE",
      payload: e
    });
  }
}

export function* onFetchLookup() {
  yield takeEvery(FETCH_LOOKUP_START, onFetchLookupAsync);
}


export function* onConfRoutCheckAsync(action) {
  try {
    yield put(showLoader(true));
    console.log("action.lookupNames", action.payload)
    const response = yield call(getConfRoutingDetailsAPI, action.payload);

    if (response.status === 200) {
      console.log(response.data)
      yield put(confRoutingCheckSuccessAct(response.data));

    }
    if (response.status !== 200) {
      yield put(confRoutingCheckFailureAct(response.data));

    }
  } catch (e) {
    //  if (e?.response?.status === 403) {
    //    yield put(refreshApp(true));
    //  }
    yield put(confRoutingCheckFailureAct(e));
  }
}

export function* onConfRoutCheck() {
  yield takeEvery(CONF_ROUTING_CHECK_START, onConfRoutCheckAsync);
}



export function* onGetConfSessionIDAsync(action) {
  try {
    yield put(showLoader(true));
    console.log("action.onGetConfSessionIDAsync", action.payload)
    const response = yield call(getConfSessionIDAPI, action.payload);

    if (response.status === 200) {
      console.log(response.data)
      yield put(getConfSessionIDSuccessAct(response.data));

    }
    if (response.status !== 200) {
      yield put(getConfSessionIDFailureAct(response.data));

    }
  } catch (e) {
    //  if (e?.response?.status === 403) {
    //    yield put(refreshApp(true));
    //  }
    yield put(getConfSessionIDFailureAct(e));
  }
}

export function* onGetConfSessionID() {
  yield takeEvery(GET_CONF_SESSIONID_START, onGetConfSessionIDAsync);
}


export function* onConfCreateQuoteAsync(action) {

  try {
    yield put(showLoader(true));
    console.log("action.confCreateQuoteAsync", action.payload)
    const response = yield call(confCreateQuoteAPI, action.payload);

    if (response.status === 200) {
      console.log(response.data)
      yield put(confCreateQuoteSuccessAct(response.data));

    }
    if (response.status !== 200) {
      yield put(confCreateQuoteFailureAct(response.data));

    }
  } catch (e) {
    //  if (e?.response?.status === 403) {
    //    yield put(refreshApp(true));
    //  }
    yield put(confCreateQuoteFailureAct(e));
  }
}

export function* onConfCreateQuote() {
  yield takeEvery(CONFIT_CREATE_QUOTE_START, onConfCreateQuoteAsync);
}

export function* onConfUpdateQuoteAsync(action) {

  try {
    yield put(showLoader(true));
    console.log("action.confUpdateQuoteAsync", action.payload)
    const response = yield call(confUpdateQuoteAPI, action.payload);
    console.log("action.response", response)
    if (response.status === 200) {
      console.log(response.data)
      yield put(confUpdateQuoteSuccessAct(response.data));

    }
    if (response.status !== 200) {
      yield put(confUpdateQuoteFailureAct(response.data));

    }
  } catch (e) {
    //  if (e?.response?.status === 403) {
    //    yield put(refreshApp(true));
    //  }
    yield put(confUpdateQuoteFailureAct(e));
  }
}

export function* onConfUpdateQuote() {
  yield takeEvery(CONFIT_UPDATE_QUOTE_START, onConfUpdateQuoteAsync);
}

